import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { withTranslation } from "react-i18next";

import AuthService from "../services/auth.service";

import ReCaptcha from "react-google-recaptcha";

const required = (t) => (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        {t("requiredField")}
      </div>
    );
  }
};

const email = (t) => (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        {t("invalidEmail")}
      </div>
    );
  }
};

const vusername = (t) => (value) => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        {t("usernameLength")}
      </div>
    );
  }
};

const vpassword = (t) => (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        {t("passwordLength")}
      </div>
    );
  }
};

const vsafe = (t) => (value) => {
  if (/[<>$]/.test(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        {t("invalidCharacters")}
      </div>
    );
  }
};

class Register extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      email: "",
      password: "",
      showPassword: false,
      successful: false,
      message: "",
      recaptcha: null
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  toggleShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    });
  };

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (process.env.REACT_APP_TEST_ENVIRONMENT === "true") {
      if (this.checkBtn.context._errors.length === 0) {
        AuthService.register(
          this.state.username,
          this.state.email,
          this.state.password
        ).then(
          response => {
            this.setState({
              message: this.props.t(response.data.message),
              successful: true
            });
          },
          error => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();

            this.setState({
              successful: false,
              message: resMessage
            });
          }
        );
      }
      return;
    }

    if (!this.state.recaptcha) {
      this.setState({
        message: this.props.t("verifyHuman"),
        successful: false
      });
      return;
    } else if (this.state.recaptcha === "") {
      this.setState({
        message: this.props.t("completeRecaptcha"),
        successful: false
      });
      return;
    } else {
      // call recaptcha verification service
      AuthService.verifyRecaptcha(this.state.recaptcha)
        .then(response => {
          if (response.data.message === "Recaptcha verified successfully.") {
            if (this.checkBtn.context._errors.length === 0) {
              AuthService.register(
                this.state.username,
                this.state.email,
                this.state.password
              ).then(
                response => {
                  this.setState({
                    message: this.props.t(response.data.message),
                    successful: true
                  });
                },
                error => {
                  const resMessage =
                    (error.response &&
                      error.response.data &&
                      error.response.data.message) ||
                    error.message ||
                    error.toString();

                  this.setState({
                    successful: false,
                    message: resMessage
                  });
                }
              );
            }
          } else {
            this.setState({
              message: this.props.t("recaptchaFail"),
              successful: false
            });
          }
        })
        .catch(error => {
          this.setState({
            message: this.props.t("recaptchaFail"),
            successful: false
          });
        });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="col-md-12">
        <div className="card card-container">
          <img
            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
            alt="profile-img"
            className="profile-img-card"
          />

          <Form
            onSubmit={this.handleRegister}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                <div className="form-group">
                  <label htmlFor="username">{t("username")}</label>
                  <Input
                    id="username-input"
                    type="text"
                    className="form-control"
                    name="username"
                    value={this.state.username}
                    onChange={this.onChangeUsername}
                    validations={[required(t), vusername(t), vsafe(t)]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{t("email")}</label>
                  <Input
                    id="email-input"
                    type="text"
                    className="form-control"
                    name="email"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    validations={[required(t), email(t), vsafe(t)]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">{t("password")}</label>
                  <div className="input-group">
                    <Input
                      id="password-input"
                      type={this.state.showPassword ? "text" : "password"}
                      className="form-control"
                      name="password"
                      value={this.state.password}
                      onChange={this.onChangePassword}
                      validations={[required(t), vpassword(t), vsafe(t)]}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" onClick={this.toggleShowPassword} style={{ cursor: 'pointer' }}>
                        {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <button id="signup-button" className="btn btn-primary btn-block">{t("signUp")}</button>
                </div>

                {process.env.REACT_APP_TEST_ENVIRONMENT !== "true" && (
                  <div className="form-group">
                    <div className="d-flex justify-content-center">
                      <ReCaptcha
                        id="recaptcha-register"
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        size="compact"
                        onChange={value => {
                          this.setState({
                            recaptcha: value
                          });
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alert alert-success"
                      : "alert alert-danger"
                  }
                  role="alert"
                >
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Register);
